import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectCounts = state => state.counts;

const makeSelectCount = (namespace: string) =>
    createDeepEqualSelector(
        selectCounts,
        countsState => countsState && countsState[namespace]
    );

export { makeSelectCount };
